import { render } from "./page-beranda.vue?vue&type=template&id=ce263bae&scoped=true"
import script from "./page-beranda.vue?vue&type=script&lang=js"
export * from "./page-beranda.vue?vue&type=script&lang=js"

import "./page-beranda.vue?vue&type=style&index=0&id=ce263bae&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce263bae"]])

export default __exports__